import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {PropertyGroup} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {createProp} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/0->1-migration';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

const MIGRATED_VERSION:DesignerVersion = 29;

export const migration_28_29:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {id, componentDesc} = boxSnapshot;

                        const dndPropSnapshot:any = createProp(
                            componentDesc.boxId,
                            componentDesc.visualComponentId,
                            SystemPropsConfigs.basePropertiesConfigs.get(SystemPropsConfigs.DND_PROP_NAME),
                            PropertyGroup.Base
                        );

                        componentDesc._baseProperties[dndPropSnapshot.id] = dndPropSnapshot;

                        if( !componentDesc._baseEventProps )
                        {
                            const onDragStartedSnapshot = {
                                id: IdUtil.newGUID(),
                                name: 'onDragStarted',
                                boxId: id,
                                isEnabled: false,
                                bindingId: null
                            };
                            const onDragInProgressSnapshot = {
                                id: IdUtil.newGUID(),
                                name: 'onDragInProgress',
                                boxId: id,
                                isEnabled: false,
                                bindingId: null
                            };
                            const onDropSnapshot = {
                                id: IdUtil.newGUID(),
                                name: 'onDrop',
                                boxId: id,
                                isEnabled: false,
                                bindingId: null
                            };

                            componentDesc._baseEventProps = {
                                [onDragStartedSnapshot.id]: onDragStartedSnapshot,
                                [onDragInProgressSnapshot.id]: onDragInProgressSnapshot,
                                [onDropSnapshot.id]: onDropSnapshot
                            };
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
